import * as Yup from 'yup';

const getValidationSchema = Yup.object().shape({
  tripIntention: Yup.number()
    .test('req', 'Поле "Тип заїзду" обов\'язкове', (value) => !!value)
    .required('Поле "Тип заїзду" обов\'язкове'),
});

export default getValidationSchema;
